import { api, get } from '../../../lib/api';

const API_BASE = '/api/client_admin/goals';

// Fetch all goals
export const fetchGoals = async () => {
  return get(API_BASE);
};

// Create a new goal
export const createGoal = async goalData => {
  const response = await api.post(API_BASE, { goal: goalData });
  return response.data;
};

// Copy an existing goal
export const copyGoal = async id => {
  const response = await api.post(`${API_BASE}/${id}/copy`);
  return response.data;
};

// Update an existing goal
export const updateGoal = async ({ id, ...goalData }) => {
  const response = await api.patch(`${API_BASE}/${id}`, { goal: goalData });
  return response.data;
};

// Delete a goal
export const deleteGoal = async id => {
  const response = await api.delete(`${API_BASE}/${id}`);
  return response.data;
};

// Reorder goals (for drag and drop)
export const reorderGoals = async goals => {
  const response = await api.patch(`${API_BASE}/reorder`, {
    reorder: { goals },
  });
  return response.data;
};
